<template>
  <div @click="$emit('select-training', training._id)">
    <mdb-card>
      <mdb-card-body style="height:200px">
        <mdb-card-text  >
          <div class="title bolder" >{{training.name}}</div>
          <div class="my-1">기간: {{$strDate(training.startDate)}}~{{$strDate(training.endDate)}}</div>
          <div class="my-1">강사: {{training.teacher.name}}</div>
          <mdb-progress class="my-2" :height="20" :value="progress" color="indigo">{{progress}}%</mdb-progress>
        </mdb-card-text>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>
<script>
import { mdbCard, mdbCardBody, mdbCardText, mdbProgress } from 'mdbvue';
import Training from '@/models/Training';
export default {
  name: 'TrainingCard',
  components: { mdbCard, mdbCardBody, mdbCardText, mdbProgress },
  props: ['training'],
  data: () => ({
  }),
  computed: {
    progress () {
      return this.$progress(this.training.startDate, this.training.endDate)
    }
  }
}
</script>
